<template>
  <div class="page-artist">
    <el-card shadow="never">
      <div class="toolbar">
        <el-button type="primary" icon="el-icon-plus" @click="openCreate">新建艺人</el-button>
      </div>
      <el-table v-loading="loading" :data="list" border stripe style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="艺人名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="sortOrder" label="排序" width="90" align="center" />
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #f56c6c" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, sizes, prev, pager, next"
        :total="total"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        :current-page.sync="page"
        @size-change="handleSizeChange"
        @current-change="fetchList"
      />
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="480px" append-to-body @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px">
        <el-form-item label="艺人名称" prop="name">
          <el-input v-model.trim="form.name" maxlength="128" show-word-limit placeholder="与前台展示的鉴别艺人一致" />
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" :max="999999" :step="1" controls-position="right" style="width: 100%" />
        </el-form-item>
        <p class="hint">排序数值越小越靠前；证书档案中从此处选择艺人。</p>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { artistPageApi, artistCreateApi, artistUpdateApi, artistDeleteApi } from '../api/artist'

const emptyForm = () => ({
  id: null,
  name: '',
  sortOrder: 0
})

export default {
  name: 'ArtistManage',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      size: 10,
      dialogVisible: false,
      dialogTitle: '',
      saving: false,
      form: emptyForm(),
      formRules: {
        name: [{ required: true, message: '必填', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.page = 1
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await artistPageApi({ page: this.page - 1, size: this.size })
        const d = res.data || {}
        this.list = d.content || []
        this.total = d.totalElements || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.dialogTitle = '新建艺人'
      this.form = emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    openEdit(row) {
      this.dialogTitle = '编辑艺人'
      this.form = {
        id: row.id,
        name: row.name,
        sortOrder: row.sortOrder != null ? row.sortOrder : 0
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    resetForm() {
      this.form = emptyForm()
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          const payload = { name: this.form.name, sortOrder: this.form.sortOrder != null ? this.form.sortOrder : 0 }
          if (this.form.id) {
            await artistUpdateApi(this.form.id, payload)
            this.$message.success('已保存')
          } else {
            await artistCreateApi(payload)
            this.$message.success('已创建')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(e.message || '保存失败')
        } finally {
          this.saving = false
        }
      })
    },
    remove(row) {
      this.$confirm(`确定删除艺人「${row.name}」吗？若已被证书引用将无法删除。`, '提示', {
        type: 'warning'
      })
        .then(async () => {
          await artistDeleteApi(row.id)
          this.$message.success('已删除')
          this.fetchList()
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar {
  margin-bottom: 12px;
}

.pager {
  margin-top: 16px;
  text-align: right;
}

.hint {
  margin: 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
